<template>
    <div class="workbench-container">
        <div style="background-color: white; height: 100%; border-radius: 10px; padding:20px">
            <!-- 页面标题 -->
            <div class="page-header">
                <h2>我的工作台</h2>
            </div>
            <!-- 主要内容区域 -->
            <div class="main-content">
                <!-- 左侧日历区域 -->
                <div class="calendar-section">
                    <div class="calendar-container">
                        <!-- 日历头部 -->
                        <div class="calendar-header">
                            <div class="month-year">{{ currentYear }} 年 {{ currentMonth }} 月</div>
                            <div class="nav-buttons">
                                <button class="nav-btn" @click="previousMonth">上个月</button>
                                <button class="nav-btn" @click="goToToday">今天</button>
                                <button class="nav-btn" @click="nextMonth">下个月</button>
                            </div>
                        </div>

                        <!-- 日历网格 -->
                        <div class="calendar-grid">
                            <!-- 星期标题 -->
                            <div class="weekdays">
                                <div class="weekday" v-for="day in weekdays" :key="day">{{ day }}</div>
                            </div>

                            <!-- 日期网格 -->
                            <div class="days-grid">
                                <div v-for="day in calendarDays" :key="day.key" :class="['day-cell', {
                                    'current-day': day.isCurrentDay,
                                    'other-month': day.isOtherMonth,
                                    'current-day': day.isSelected
                                }]" @click="selectDate(day)">
                                    {{ day.date }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧待办提醒区域 -->
                <div class="reminder-section">
                    <div class="reminder-container">
                        <div class="reminder-title">待办提醒</div>
                        <div class="reminder-grid">
                            <div v-for="reminder in reminders" :key="reminder.id" class="reminder-card">
                                {{ reminder.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { getUserInfo } from '@/api/modules/user'
export default {
    name: 'Workbench',
    data() {
        return {
            currentYear: 2025,
            currentMonth: 8,
            selectedDate: null, // 选中的日期
            weekdays: ['一', '二', '三', '四', '五', '六', '日'],
            reminders: [
                { id: 1, text: '报名审核通知' },
                { id: 2, text: '标书款核实提醒' },
                { id: 3, text: '澄清、补遗提醒' },
                { id: 4, text: '踏勘通知' },
                { id: 5, text: '解答评委提问提醒' },
                { id: 6, text: '确认开标记录提醒' },
                { id: 7, text: '开标提醒' },
                { id: 8, text: '投标截止前文件上传提醒' },
                { id: 9, text: '所投项目中标公告提醒' },
                { id: 10, text: '解密提醒' },
                { id: 11, text: '中标候选人公示发布提醒' },
                { id: 12, text: '下载招标文件提醒' },
                { id: 13, text: '质疑' }
            ]
        }
    },
    computed: {

        // 计算日历天数
        calendarDays() {
            const year = this.currentYear
            const month = this.currentMonth
            const firstDay = new Date(year, month - 1, 1)
            const lastDay = new Date(year, month, 0)
            const daysInMonth = lastDay.getDate()
            const firstDayOfWeek = (firstDay.getDay() + 6) % 7 // 转换为周一开始
            const days = []
            const prevMonth = new Date(year, month - 2, 0)
            for (let i = firstDayOfWeek - 1; i >= 0; i--) {
                days.push({
                    key: `prev-${i}`,
                    date: prevMonth.getDate() - i,
                    isOtherMonth: true,
                    isCurrentDay: false
                })
            }
            // 当前月的日期
            for (let day = 1; day <= daysInMonth; day++) {
                const isCurrentDay = day === 1
                const isSelected = this.selectedDate &&
                    this.selectedDate.year === year &&
                    this.selectedDate.month === month &&
                    this.selectedDate.day === day
                days.push({
                    key: `current-${day}`,
                    date: day,
                    isOtherMonth: false,
                    isCurrentDay: isCurrentDay,
                    isSelected: isSelected,
                    year: year,
                    month: month
                })
            }

            // 下个月的日期（填充到42个格子）
            const remainingDays = 42 - days.length
            for (let day = 1; day <= remainingDays; day++) {
                days.push({
                    key: `next-${day}`,
                    date: day,
                    isOtherMonth: true,
                    isCurrentDay: false
                })
            }

            return days
        }
    },
    mounted(){
        this.goToToday()

    },
    methods: {
        // 上个月
        previousMonth() {
            if (this.currentMonth === 1) {
                this.currentMonth = 12
                this.currentYear--
            } else {
                this.currentMonth--
            }
        },
        // 下个月
        nextMonth() {
            if (this.currentMonth === 12) {
                this.currentMonth = 1
                this.currentYear++
            } else {
                this.currentMonth++
            }
        },
        // 今天
        goToToday() {
            const today = new Date()
            this.currentYear = today.getFullYear()
            this.currentMonth = today.getMonth() + 1
            this.selectedDate = {
                year: today.getFullYear(),
                month: today.getMonth() + 1,
                day: today.getDate()
            }
        },

        // 选择日期
        selectDate(day) {
            if (day.isOtherMonth) {
                // 如果点击的是其他月份的日期，切换月份
                if (day.key.startsWith('prev-')) {
                    this.previousMonth()
                } else if (day.key.startsWith('next-')) {
                    this.nextMonth()
                }
                // 切换月份后，选中对应的日期
                this.$nextTick(() => {
                    this.selectedDate = {
                        year: this.currentYear,
                        month: this.currentMonth,
                        day: day.date
                    }
                })
            } else {
                // 点击当前月份的日期
                this.selectedDate = {
                    year: day.year,
                    month: day.month,
                    day: day.date
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.workbench-container {
    padding: 20px;
    background-color: #f0f4fb;
    height: 100%;
}

.page-header {
    padding: 10px 0px;
    border-bottom: 1px solid #e8e8e8;

    h2 {
        margin: 0;
        color: #333;
        font-size: 24px;
        font-weight: normal;
    }
}

.main-content {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    min-height: calc(100vh - 220px);
}

.calendar-section {
    flex: 1;
}

.calendar-container {
    background: white;
    border-radius: 8px;
    padding: 20px;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #e8e8e8;

    .month-year {
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }

    .nav-buttons {
        display: flex;
        gap: 8px;

        .nav-btn {
            padding: 6px 12px;
            border: 1px solid #d9d9d9;
            background: white;
            border-radius: 4px;
            cursor: pointer;
            font-size: 12px;
            color: #333;
            transition: all 0.2s;

            &:hover {
                border-color: #40a9ff;
                color: #40a9ff;
            }
        }
    }
}

.calendar-grid {
    .weekdays {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        margin-bottom: 8px;

        .weekday {
            text-align: center;
            font-size: 12px;
            color: #666;
            padding: 8px 0;
            font-weight: 500;
        }
    }

    .days-grid {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 1px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: hidden;

        .day-cell {
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            background: white;
            border-right: 1px solid #e8e8e8;
            border-bottom: 1px solid #e8e8e8;
            position: relative;

            &:nth-child(7n) {
                border-right: none;
            }

            &:nth-child(n+36) {
                border-bottom: none;
            }

            &.current-day {
                background-color: #e6f7ff;
                color: #1890ff;
                font-weight: 600;
            }

            &.selected-day {
                background-color: #1890ff;
                color: white;
                font-weight: 600;
            }

            &.other-month {
                color: #bfbfbf;
                background-color: #fafafa;
            }

            &:hover:not(.other-month) {
                background-color: #f5f5f5;
            }

            &.selected-day:hover {
                background-color: #40a9ff;
            }
        }
    }
}

.reminder-section {
    flex: 1;
}

.reminder-container {
    background: white;
    border-radius: 8px;
    padding: 20px;
}

.reminder-title {
    font-size: 16px;
    font-weight: bold;
    text-align: start;
    margin-bottom: 15px;
    color: #333;
}

.reminder-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;


    .reminder-card {
        margin-top: 20px;
        background: white;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 15px;
        font-size: 14px;
        color: #333;
        text-align: center;
        min-height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            border-color: #40a9ff;
            box-shadow: 0 2px 8px rgba(64, 169, 255, 0.2);
        }
    }
}
</style>
